<template>
  <div style="background-color: #f8fafc !important; padding: 10px" class="mb-5">
    <b-row
      v-b-toggle.role-table style="cursor: pointer;"
      class="d-flex justify-content-between mr-0 ml-0"
    >
      <h4>
        Information about Roles
      </h4>
      <font-awesome-icon icon="chevron-down" class="caretDownIcon"/>
    </b-row>
    <b-collapse id="role-table">
      <b-table
        :fields="tableHeaders"
        :items="tableContent"
        show-empty
        caption-top
        :outlined="true"
        :fixed="true"
      >
        <template slot="table-caption">
          <b-row>
            <b-col>
              <h4 style="color: black !important;">Roles</h4>
            </b-col>
            <b-col style="text-align: right;">
              <span class="mr-2">
              <font-awesome-icon icon="check-square" style="color: green"/> Full Access
            </span>
              <span class="mr-2">
              <font-awesome-icon
                icon="eye"
                style="color: darkorange"
              /> Read Only
            </span>
              <span class="mr-2">
              <font-awesome-icon icon="times-circle" style="color: red"/> No Access
            </span>
            </b-col>
          </b-row>
        </template>
        <template slot="borrower" slot-scope="row">
          <font-awesome-icon
            icon="check-square"
            style="color: green"
            v-if="row.item.borrower === true"
          />
        </template>
        <template
          :slot="column.key" slot-scope="row" v-for="column in tableHeaders.slice(2)">
          <font-awesome-icon
            :key="column.key"
            icon="check-square"
            style="color: green"
            v-if="row.item[column.key] === true"
          />
          <font-awesome-icon
            :key="column.key"
            icon="times-circle"
            style="color: red"
            v-if="row.item[column.key] === false"
          />
          <font-awesome-icon
            :key="column.key"
            icon="eye"
            style="color: darkorange"
            v-if="row.item[column.key] === 'read_only'"
          />
        </template>
      </b-table>
    </b-collapse>
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

library.add([faChevronDown]);

export default {
  name: 'RolesTable',
  props: {
    rolesDetails: Array,
  },
  computed: {
    tableHeaders() {
      const fields = [
        {
          key: 'page',
          label: '',
          tdClass: 'page-column',
        },
        {
          key: 'borrower',
          class: 'text-center',
        },
      ];
      const rolesColumns = [];
      this.rolesDetails.forEach((role, index) => {
        rolesColumns.push({ key: `${index}`, label: Object.entries(role)[0][0], class: 'text-center', perms: Object.entries(role)[0][1] });
      });

      rolesColumns.sort((a, b) => ((a.label > b.label) ? 1 : -1));
      return fields.concat(rolesColumns);
    },
    allPages() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission([
          'dashboard.read', 'loans.read', 'payments.read', 'entity.read', 'plaid.read', 'mydocs.read'], el);
      });
      line.page = 'All';
      line.borrower = true;
      return line;
    },
    dashboardPage() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['dashboard.read'], el);
      });
      line.page = 'Dashboard';
      line.borrower = true;
      return line;
    },
    dealsActivePage() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['loans.read'], el);
      });
      line.page = 'Active';
      line.borrower = true;
      return line;
    },
    dealsInProgressPage() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['loans.read'], el);
      });
      line.page = 'Deals in Progress';
      line.borrower = true;
      return line;
    },
    dealsNewPage() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['loans.write'], el);
      });
      line.page = 'New Deal';
      line.borrower = true;
      return line;
    },
    plaidLine() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['plaid.read'], el);
      });
      line.page = 'Plaid';
      line.borrower = true;
      return line;
    },
    submitDrawRequest() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['loans.draw.write'], el);
      });
      line.page = 'Submit Draw Request';
      line.borrower = true;
      return line;
    },
    submitACHRequest() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['loans.ach.write'], el);
      });
      line.page = 'Submit ACH Request';
      line.borrower = true;
      return line;
    },
    createPlaidReport() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['plaid.write'], el);
      });
      line.page = 'Plaid';
      line.borrower = true;
      return line;
    },
    entitiesDocs() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['entity.doc.write'], el);
      });
      line.page = 'Entities - Docs';
      line.borrower = true;
      return line;
    },
    drawRequestDocs() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['loans.draw.docs.write'], el);
      });
      line.page = 'Draw Requests Docs';
      line.borrower = true;
      return line;
    },
    achRequestDocs() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['loans.ach.docs.write'], el);
      });
      line.page = 'ACH Requests Docs';
      line.borrower = true;
      return line;
    },
    paymentMethodsWrite() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['payments.write'], el);
      });
      line.page = 'Payment Methods';
      line.borrower = true;
      return line;
    },
    applicationWrite() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['application.write'], el);
      });
      line.page = 'Application';
      line.borrower = true;
      return line;
    },
    myDocs() {
      const line = {};
      this.tableHeaders.forEach((el) => {
        line[`${el.key}`] = this.checkPagePermission(['mydocs.write'], el);
      });
      line.page = 'My Docs';
      line.borrower = true;
      return line;
    },
    tableContent() {
      return [
        { page: 'PAGE ACCESS', _rowVariant: 'secondary' },
        this.allPages,
        this.dealsActivePage,
        this.dashboardPage,
        this.dealsInProgressPage,
        this.dealsNewPage,
        this.plaidLine,
        { page: 'CAN DO/CHANGE', _rowVariant: 'secondary' },
        this.submitDrawRequest,
        this.submitACHRequest,
        this.createPlaidReport,
        this.entitiesDocs,
        this.drawRequestDocs,
        this.achRequestDocs,
        this.paymentMethodsWrite,
        this.applicationWrite,
        this.myDocs,
      ];
    },
  },
  methods: {
    checkPagePermission(neededPerms, element) {
      const permsAvailable = element.perms;
      if (Array.isArray(permsAvailable)) {
        if (permsAvailable.indexOf('owner') !== -1) {
          return true;
        }
        let result = true;
        neededPerms.forEach((perm) => {
          if (permsAvailable.indexOf(perm) === -1) {
            result = false;
          }
        });
        if (element.label === 'Read Only' && result) {
          result = 'read_only';
        }
        return result;
      }
      return null;
    },
  },
};
</script>

<style scoped>
:not(.collapsed) > .caretDownIcon {
  transform: rotate(180deg) !important;
}

.caretDownIcon {
  transition: all .3s linear;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/tabs/team_members/RolesTable.vue